import React from 'react';
import PropTypes from 'prop-types';
import { ConfigsService as GeneralConfigsService, LocaleService } from '@sm360/widget-commons-core-services';
import { REDIRECTIONS } from '@sm360/widget-commons-general';

const GarageCTA = ({ isNewEnabled, isUsedEnabled, usedUrl }) => {
    const locale = LocaleService.getSimpleLocale();
    const isShowroomV25Enable = GeneralConfigsService.isShowroomV25Enabled();
    const catalogUrl = isShowroomV25Enable ? REDIRECTIONS[locale].catalogNew : REDIRECTIONS[locale].catalog;
    const listingUsedUrl = usedUrl !== '' ? usedUrl : REDIRECTIONS[locale].listingPreOwnedUsed;

    const addNewVehicleLink = (isNewEnabled || isShowroomV25Enable) && (
        <a className="add-car-add-vehicle sr-button-outline-1" href={catalogUrl}>
            {LocaleService.t('GARAGE.ADD_VEHICLE_NEW_TITLE')}
        </a>
    );

    const addUsedVehicleLink = (isUsedEnabled || isShowroomV25Enable) && (
        <a className="add-car-add-vehicle sr-button-outline-1" href={listingUsedUrl}>
            {LocaleService.t('GARAGE.ADD_VEHICLE_USED_TITLE')}
        </a>
    );

    return (
        <div className="payment-CTA">
            {addNewVehicleLink}
            {addUsedVehicleLink}
        </div>
    );
};

GarageCTA.displayName = 'GarageCTA';

GarageCTA.propTypes = {
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
};

export default GarageCTA;
